import React, { useState, useEffect, useRef } from 'react';
import './ContactForm.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        correo: '',
        telefono: ''
    });

    const [showModal, setShowModal] = useState(false);
    const canvasRef = useRef(null);

    // Lógica para el fondo animado (Canvas) del nuevo diseño
    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        const ctx = c.getContext('2d');

        const draw = () => {
            const w = c.width = c.offsetWidth;
            const h = c.height = c.offsetHeight;

            ctx.clearRect(0, 0, w, h);
            ctx.strokeStyle = 'rgba(255,255,255,0.05)';
            ctx.lineWidth = 1;

            for (let x = 0; x < w; x += 80) {
                ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h); ctx.stroke();
            }
            for (let y = 0; y < h; y += 80) {
                ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke();
            }

            const g = ctx.createRadialGradient(w * 0.5, h * 0.5, 0, w * 0.5, h * 0.5, w * 0.55);
            g.addColorStop(0, 'rgba(255,255,255,0.07)');
            g.addColorStop(1, 'rgba(255,255,255,0)');

            ctx.fillStyle = g;
            ctx.fillRect(0, 0, w, h);
        };

        draw();
        window.addEventListener('resize', draw);
        return () => window.removeEventListener('resize', draw);
    }, []);

    const handleChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            const response = await fetch('https://n8n-produccion.navi-ol.xyz/webhook/contacto', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setShowModal(true);
                setFormData({ nombre: '', apellido: '', correo: '', telefono: '' });
            } else {
                alert('Hubo un problema al enviar el mensaje. Por favor intenta de nuevo.');
            }
        } catch (error) {
            console.error('Error al enviar:', error);
            alert('Hubo un error de conexión al enviar el formulario');
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <section className="cta-s" id="contacto">
            {/* Fondo decorativo */}
            <canvas id="ctaCvs" ref={canvasRef}></canvas>

            <div className="cta-content">
                <div className="cta-ey rv in">¿Listo para empezar?</div>
                <h2 className="cta-t rv in">Cuéntanos tu reto.<br />Nosotros lo resolvemos.</h2>
                <p className="cta-st rv in">La primera conversación no tiene costo — y puede cambiar cómo opera tu empresa.</p>

                {/* Formulario integrado al nuevo diseño */}
                <form className="contact-form rv in" onSubmit={handleSubmit}>
                    <div className="form-row">
                        <input
                            type="text"
                            name="nombre"
                            placeholder="Nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="apellido"
                            placeholder="Apellido"
                            value={formData.apellido}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <input
                        type="email"
                        name="correo"
                        placeholder="Correo electrónico"
                        value={formData.correo}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="tel"
                        name="telefono"
                        placeholder="Teléfono (Opcional)"
                        value={formData.telefono}
                        onChange={handleChange}
                    />
                    <button type="submit" className="btn btn-white submit-btn">
                        Enviar Solicitud
                    </button>
                </form>
            </div>

            {/* --- VENTANA MODAL (Adaptada visualmente) --- */}
            {showModal && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>&times;</button>

                        <div className="modal-icon">🚀</div>

                        <h3>¡Todo listo!</h3>

                        <p>
                            Hemos recibido tu solicitud correctamente. En breves instantes recibirás un correo
                            con los <strong>primeros pasos a seguir</strong>.
                        </p>

                        <div className="modal-promo">
                            <p>Mientras esperas, descubre cómo la IA está transformando otros negocios:</p>
                            <a href="/blog" className="btn btn-blue modal-btn-link">
                                Visitar el Blog &rarr;
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ContactForm;
